"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicRoutes = void 0;
const route_1 = require("../route");
class PublicRoutes extends route_1.Route {
    constructor() {
        super('public');
    }
    getUserFromTag(tag) {
        return this.get(`/tag/${tag}`);
    }
    getPublicUserInfo(userId) {
        return this.get(`/users/${userId}`);
    }
    getAuthPlatform() {
        return this.get('/auth/platform');
    }
    getIPAddress() {
        return this.get('/ip');
    }
    isUserVerified(userId) {
        return this.get(`/verified/${userId}`);
    }
    getPublicOrderInfo(orderId) {
        return this.get(`/orders/${orderId}`);
    }
    initializeOrder(orderDetails) {
        return this.post('/orders/initialize', orderDetails);
    }
    getOrderTemplate(templateId) {
        return this.get(`/orders/templates/${templateId}`);
    }
    initializeOrderFromTemplate(templateId) {
        return this.post(`/orders/from-template/${templateId}`);
    }
}
exports.PublicRoutes = PublicRoutes;
//# sourceMappingURL=public.js.map